import { useEffect, useState } from 'react';

/**
 * "Agora" que se atualiza sozinho, para os horários relativos ("há 5 min", "ontem às 14:30")
 * continuarem certos com o painel aberto o dia todo. Também atualiza ao voltar para a aba: os
 * navegadores atrasam os temporizadores de abas em segundo plano, e o horário ficaria velho.
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const refresh = (): void => setNow(new Date());
    const timer = setInterval(refresh, intervalMs);
    const onVisible = (): void => {
      if (document.visibilityState === 'visible') refresh();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [intervalMs]);

  return now;
}
